import { SUPPORTED_GAMES_HREF } from "@/v2-components/pages/games/GamesSubNav";
// API configuration for About page
export const API_CONFIG = {
  production: {
    YOUTUBE_DATA_API_PREFIX: "https://www.googleapis.com/youtube/v3",
    YOUTUBE_API_KEY: "AIzaSyCoveYCX7HfwDZZ1s7pEgeV85zDxd4z1qo",
  },
  development: {
    YOUTUBE_DATA_API_PREFIX: "https://www.googleapis.com/youtube/v3",
    YOUTUBE_API_KEY: "AIzaSyA_mIg5pcELw5sXOx_7C69vX0BQsMQL6BU",
  },
};

export const getApiConfig = () => {
  return process.env.NEXT_PUBLIC_ENV === "production"
    ? API_CONFIG.production
    : API_CONFIG.development;
};

// YouTube video IDs for about page
export const ABOUT_VIDEO_IDS = [
  "PPJoYQlDwIc",
  "CJpl2CX0Yys",
  "AJLuJlyt4Ho",
  "TxXLWlVzVHU",
  "zXwq1tiMy_o",
  "BMwFlIr4Z1w",
];

// Media constants
export const MEDIA_URLS = {
  DESKTOP_VIDEO: "https://cdn.bhaptics.com/media/anniv_10-1080.mp4",
  MOBILE_VIDEO: "https://cdn.bhaptics.com/media/anniv_10-720.mp4",
  POSTER: "/images/event/anniversary/anniversary_video_poster@2x.png",
};

// Timeline data
export const TIMELINE_DATA = [
  {
    year: "2024",
    images: [
      {
        src: "/images/about/prize/mfm.jpg",
        alt: "Made for Meta (TactSuit X40 and X16)",
      },
      {
        src: "/images/about/devices/glove.png",
        alt: "TactGlove DK2",
      },
      {
        src: "/images/about/devices/pro+air+sleeve.png",
        alt: "TactSuit Pro/Air, TactSleeve",
      },
    ],
  },
  {
    year: "2023",
    images: [
      {
        src: "/images/about/devices/visor.png",
        alt: "TactVisor",
      },
      {
        src: "/images/about/devices/glove-dk1.jpg",
        alt: "TactGlove DK1",
      },
    ],
  },
  {
    year: "2022",
    images: [
      {
        src: "/images/about/devices/glove-proto.jpg",
        alt: "TactGlove Prototype",
      },
    ],
  },
  {
    year: "2021",
    images: [
      {
        src: "/images/about/prize/auggie-awards.jpg",
        alt: "Auggie Awards (TactSuit X40)",
      },
      {
        src: "/images/about/prize/if-awards.jpg",
        alt: "iF Design Award (TactSuit X40)",
      },
      {
        src: "/images/about/prize/ces.jpg",
        alt: "CES Innovation Award (TactSuit X40)",
      },
    ],
  },
  {
    year: "2017",
    images: [
      {
        src: "/images/about/devices/tactot.png",
        alt: "Tactot Prototype",
      },
      {
        src: "/images/about/devices/tactot-dk1.png",
        alt: "Tactot DK1",
      },
      {
        src: "/images/about/devices/tal+tactosy.png",
        alt: "Tactosy for Hands/Feet, Tactal",
      },
    ],
  },
  {
    year: "2018",
    images: [
      {
        src: "/images/about/devices/tactot-dk2.png",
        alt: "Tactot DK2",
      },
      {
        src: "/images/about/devices/arms.jpg",
        alt: "Tactosy for Arms",
      },
    ],
  },
  {
    year: "2019",
    images: [
      {
        src: "/images/about/devices/tactot-dk3.png",
        alt: "Tactot DK3",
      },
    ],
  },
  {
    year: "2020",
    images: [
      {
        src: "/images/about/devices/x40+x16.png",
        alt: "TactSuit X40/X16",
      },
    ],
  },
  {
    year: "2016",
    images: [
      {
        src: "/images/about/devices/tactosy-prototype-2.png",
        alt: "Tactosy",
      },
    ],
  },
  {
    year: "2015",
    images: [
      {
        src: "/images/about/devices/tactosy-prototype-1.png",
        alt: "Early Prototype for Arms",
      },
    ],
  },
];

export const MOBILE_TIMELINE_DATA = [
  {
    year: "May 2015",
    type: "device",
    image: {
      src: "/images/about/devices/tactosy-prototype-1.png",
      alt: "Early Prototype for Arms",
    },
  },
  {
    year: "Dec 2016",
    type: "device",
    image: {
      src: "/images/about/devices/tactosy-prototype-2.png",
      alt: "Tactosy",
    },
  },
  {
    year: "Jun 2017",
    type: "device",
    image: {
      src: "/images/about/devices/tactot.png",
      alt: "Tactot Prototype",
    },
  },
  {
    year: "Aug 2017",
    type: "device",
    image: {
      src: "/images/about/devices/tactot-dk1.png",
      alt: "Tactot DK1",
    },
  },
  {
    year: "Nov 2017",
    type: "device",
    image: {
      src: "/images/about/devices/tal+tactosy.png",
      alt: "Tactosy for Hands/Feet, \nTactal",
    },
  },
  {
    year: "Mar 2018",
    type: "device",
    image: {
      src: "/images/about/devices/tactot-dk2.png",
      alt: "Tactot DK2",
    },
  },
  {
    year: "Dec 2018",
    type: "device",
    image: {
      src: "/images/about/devices/arms.jpg",
      alt: "Tactosy for Arms",
    },
  },
  {
    year: "Jan 2019",
    type: "device",
    image: {
      src: "/images/about/devices/tactot-dk3.png",
      alt: "Tactot DK3",
    },
  },
  {
    year: "Nov 2020",
    type: "device",
    image: {
      src: "/images/about/devices/x40+x16.png",
      alt: "TactSuit X40/X16",
    },
  },
  {
    year: "Jan 2021",
    type: "award",
    image: {
      src: "/images/about/prize/ces.jpg",
      alt: "CES Innovation Awards \nTactSuit X40)",
    },
  },
  {
    year: "May 2021",
    type: "award",
    image: {
      src: "/images/about/prize/if-awards.jpg",
      alt: "iF Design Award \n(TactSuit X40)",
    },
  },
  {
    year: "Nov 2021",
    type: "award",
    image: {
      src: "/images/about/prize/auggie-awards.jpg",
      alt: "Auggie Awards \n(TactSuit X40)",
    },
  },
  {
    year: "Jan 2022",
    type: "device",
    image: {
      src: "/images/about/devices/glove-proto.jpg",
      alt: "TactGlove Prototype",
    },
  },
  {
    year: "Feb 2023",
    type: "device",
    image: {
      src: "/images/about/devices/glove-dk1.jpg",
      alt: "TactGlove DK1",
    },
  },
  {
    year: "Jun 2023",
    type: "device",
    image: {
      src: "/images/about/devices/visor.png",
      alt: "TactVisor",
    },
  },
  {
    year: "Apr 2024",
    type: "award",
    image: {
      src: "/images/about/prize/mfm.jpg",
      alt: "Made for Meta \n(TactSuit X40 and X16)",
    },
  },
  {
    year: "May 2024",
    type: "device",
    image: {
      src: "/images/about/devices/glove.png",
      alt: "TactGlove DK2",
    },
  },
  {
    year: "Nov 2024",
    type: "device",
    image: {
      src: "/images/about/devices/pro+air+sleeve.png",
      alt: "TactSuit Pro/Air TactSleeve",
    },
  },
];

/**
 * `/about` 의 플랫폼 카드 6장 — **개편 화면으로 보낸다** (#5648 후속).
 *
 * 종전 목적지는 전부 `/games/search/?filter=<platform>` 이었다. 그 화면은 renewal_v2
 * 이전 것이고 **아직 200 이라 404 가 안 난다** — 서브내비도 좌측 필터 레일도 없는 옛
 * 목록으로 떨어질 뿐이라 눈으로는 정상으로 보인다.
 *
 * ## 목적지가 두 목록으로 갈린다 — 값이 스스로 정한다
 *
 * ```
 *   quest · steam · psvr2 · rift   →  /games/vr/games/?platform=<값>
 *   simracing                      →  /games/pc/games/?genre=simracing
 *   pc                             →  /games/pc/games/          (PC 목록엔 platform 필터가 없다)
 * ```
 *
 * ## ★경로는 **정본을 경유**한다 — 리터럴로 손복사하지 않는다 (R1 M1)
 *
 * 목적지 정본은 `SUPPORTED_GAMES_HREF`(`GamesSubNav.tsx`)다. 초판은 12자리를 전부
 * 리터럴로 적었고, 그러면 **한 목적지가 두 표기로 존재**한다 — 다음 사람이 정본을
 * 재사용하면 조용히 갈린다. 쿼리가 붙는 형태만 `/` 를 넣는다(`${…}/?platform=…`) —
 * 그게 `ImmersionBeyondComparison` 이 이미 쓰는 모양이다.
 *
 * ```
 * ```
 *
 * VR 목록은 `platform` 을 읽고(`use-vr-games-filters.ts` `GROUP_DEFS`), 허용 값은
 * `VR_PLATFORM_VALUES`(steam·quest·rift·vive·psvr2·pico)다. PC 목록이 읽는 것은
 * `support`·`genre`·`q`·`sort` 뿐이라 **플랫폼 축이 없다** — 그래서 `pc` 는 맨 목록으로,
 * `simracing` 은 `PcGenreKey` 인 장르로 간다.
 *
 * 실측(2026-09-09 dev · 카드 수):
 *
 * ```
 *   /games/vr/games/                    73
 *   /games/vr/games/?platform=quest     19
 *   /games/vr/games/?platform=psvr2     14
 *   /games/vr/games/?platform=rift      12
 *   /games/pc/games/?genre=simracing    26
 * ```
 *
 * ⚠️ `steam` 은 위 실측에서 빠졌다 — 나머지 셋과 **같은 `platform` 축**이라 별도 확인을
 * 생략했다. 다시 재려면 `?platform=steam` 으로 같은 페이지를 연다.
 */
export const GAME_PLATFORM_LINKS = [
  {
    href: `${SUPPORTED_GAMES_HREF.vr}/?platform=quest`,
    icon: "MetaIcon",
    bgColor: "bg-blue-60",
    title: "Meta Quest",
  },
  {
    href: `${SUPPORTED_GAMES_HREF.vr}/?platform=steam`,
    icon: "SteamIcon",
    bgColor: "bg-blue-90",
    title: "Steam VR",
  },
  {
    href: `${SUPPORTED_GAMES_HREF.vr}/?platform=psvr2`,
    icon: "PSVRIcon",
    bgColor: "bg-blue-80",
    title: "PSVR2",
  },
  {
    href: `${SUPPORTED_GAMES_HREF.pc}/?genre=simracing`,
    icon: "SimRacingIcon",
    bgColor: "bg-orange-50",
    title: "Sim Racing",
  },
  {
    href: SUPPORTED_GAMES_HREF.pc,
    icon: "PCPlatformIcon",
    bgColor: "bg-green-50",
    title: "PC Game",
  },
  {
    href: `${SUPPORTED_GAMES_HREF.vr}/?platform=rift`,
    icon: "OculusIcon",
    bgColor: "bg-coolgray-90",
    title: "Rift",
  },
];

// Partner data
export const PARTNER_DATA = {
  lbe: [
    { name: "Hologate", component: "Hologate" },
    { name: "Sandbox", component: "Sandbox" },
    { name: "Vex", component: "Vex" },
  ],
  distribution: [
    { name: "Tekzone", component: "Tekzone" },
    { name: "Unbound", component: "Unbound" },
    { name: "Knoxlabs", component: "Knoxlabs" },
    { name: "Immersive Display", component: "ImmersiveDisplay" },
    { name: "Invelon", component: "Invelon" },
    { name: "Ask", component: "Ask" },
    { name: "Taobao", component: "Taobao" },
  ],
};

// Contact information
export const CONTACT_INFO = [
  {
    title: "Interested in distributing bHaptics products?",
    subtitle: "Contacts us at bd@bhaptics.com.",
    href: "mailto:bd@bhaptics.com",
  },
  {
    title: "Interested in developing with bHaptics?",
    subtitle: "Visit our Developer Support Site.",
    href: "/support/developers/?type=sdk",
  },
  {
    title: "Interested in creating content for bHaptics?",
    subtitle: "Email our Marketing team at marketing@bhaptics.com.",
    href: "mailto:marketing@bhaptics.com",
  },
];
